import { render, staticRenderFns } from "./ClientesVendas.vue?vue&type=template&id=3e22034e&scoped=true&lang=pug&"
import script from "./ClientesVendas.vue?vue&type=script&lang=js&"
export * from "./ClientesVendas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e22034e",
  null
  
)

export default component.exports